/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// import { AppEnvConfig } from '../../../app.config';
// import { UserService } from '../../../../user.service';
// import { SSDWidgetServiceConstants } from '../../../ssd-widgets/_enum/service-constants';
import { AppEnvConfig } from '../../../../../../../../app/app.env.config';
import { UserService } from '../../../../../../../../app/core/user/user.service';
import { environment } from '../../../../../../../../environments/environment';
import { EvaRequestPayload, EvaResponse } from '../models/eva-request.model';
import { EvaState } from '../models/eva-state.model';
import { AIAgentServiceConfig } from './ai-agent.service.config';
// import { AppEnvConfig } from '../../../app.env.config';

@Injectable({
    providedIn: 'root'
})
export class AIAgentService {
    private conversationId$ = new BehaviorSubject<string>('');
    private evaState$ = new BehaviorSubject<EvaState>({ show: false, prompt: '' });
    private sessionId: string;
    private apiUrl = ''; // OpenAI API URL
    private apiKey = ''; // Replace with your OpenAI API key
    private configEnv: any;
    private cachedUserSettings: any = null;
    private cachedUserSettingsKey: string = '';

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private httpClient: HttpClient,
        private config: AppEnvConfig,
        private aiAgentServiceConfig: AIAgentServiceConfig
    ) {
        this.configEnv = this.aiAgentServiceConfig.getEnvironment();
        // this.configEnv.apiWaterServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_WATER_SERVER_URL);
        // this.configEnv.apiPlatformServerUrl = this.config.getEnv(SSDWidgetServiceConstants.API_SERVER_URL);
    }
    public getDefaultCorporateId(): number | undefined {
        const userSettings = this.getCurrentUserSettings();

        if (userSettings?.DefaultContextPointId) {
            return Number(userSettings.DefaultContextPointId);
        }

        if (userSettings?.Accounts?.[0]?.AccountId) {
            return Number(userSettings.Accounts[0].AccountId);
        }

        return undefined;
    }
    public getCurrentUserSettings() {
        if (typeof window === 'undefined') {
            return {};
        }

        const value = sessionStorage.getItem('ecolab.envision_UserSettings');

        if (value === this.cachedUserSettingsKey && this.cachedUserSettings) {
            return this.cachedUserSettings;
        }

        if (!value) {
            return {};
        }

        try {
            this.cachedUserSettings = JSON.parse(value);
            this.cachedUserSettingsKey = value;
            return this.cachedUserSettings;
        } catch {
            return {};
        }
    }

    public getEVAResponse(payload: EvaRequestPayload): Observable<EvaResponse | null> {
        const url = environment.intelligenceAggrServiceUrl + this.configEnv.apiUrl.getEvaResponse;
        return this.httpClient.post<EvaResponse>(url, payload).pipe(
            map(response => response),
            catchError(error => {
                console.error('Error calling EVA API:', error);
                return of(null);
            })
        );
    }

    /**
     * Get the EVA state observable to subscribe to EVA visibility and prompt changes
     */
    public getEvaState$(): Observable<EvaState> {
        return this.evaState$.asObservable();
    }

    /**
     * Update the EVA state to show/hide EVA and set the prompt
     */
    public setEvaState(state: EvaState): void {
        this.evaState$.next(state);
    }

}